import { DocumentStateBase } from "@/services/backend/documents/types/state";
import { Document, Artefact } from "@bitory-gmbh/bsm";
import { Common } from "@/services/backend/documents/types/common";
import { Reference } from "@/services/backend/documents/types/reference-number";

export interface LastMinuteRiskAnalysis
  extends Document, Artefact, DocumentStateBase, Common, Reference {
  conductedBy: string;
  confirmed: boolean;
  confirmedBy: string;
  confirmedAt: string;
  checks: Check[];
}

export interface Check {
  id: string;
  number: number;
  description: string;
  checked: boolean;
  options: string[];
  multiple: boolean;
  result: number;
  selected: number[];
  comment: string;
  withComment: boolean;
  children: Check[];
  childrenIfResultOneOf: number[];
}

export function checkRequiresChildren(check: Check): boolean {
  if (!check.checked) {
    return false;
  }
  if (check.childrenIfResultOneOf == null) {
    return false;
  }
  return check.childrenIfResultOneOf.includes(check.result);
}
